@let isMobile = breakpoints() === "mobile";
<header class="header">
  <div
    [class.header-content-images]="data().images.length > 1"
    [class.header-content-social]="data().socialNetworks && data().socialNetworks!.length"
    class="header-content">
    @if (data().images[0]; as image) {
      <app-image [image]="image" [isPriority]="true" class="img-background" />
    }
    <div class="content-wrapper">
      <div [ngClass]="{ 'is-banner-displayed': isPromotionBanner() && isPromotionAllowed() }" class="row container top">
        <app-breadcrumb class="breadcrumb" color="WHITE" />
      </div>
      <div class="row container">
        <div
          [class.col-lg-6]="data().images[1] || data().images[2]"
          [class.col-lg-9]="!(data().images[1] || data().images[2])"
          class="col-xs-12">
          <div class="content">
            @if (subtitle()) {
              <app-title [titles]="[subtitle()]" />
            }
            @if (title()) {
              <app-title [titles]="[title()]" class="title" />
            }
            @if (isMiddleOfficeToken$ | async) {
              <app-middle-office-button [type]="'EDIT_HERO'" class="middle-office" />
            }
            @if (data().socialNetworks && data().socialNetworks!.length && isMobile) {
              <app-social-networks
                [items]="data().socialNetworks!"
                [style]="socialNetworksStyle()"
                class="social-networks" />
            }
          </div>
        </div>
        <div class="col-lg-3 end-lg is-desktop">
          @if (data().socialNetworks && data().socialNetworks!.length && !isMobile) {
            <app-social-networks
              [items]="data().socialNetworks!"
              [style]="socialNetworksStyle()"
              class="social-networks" />
          }
        </div>
      </div>
    </div>
  </div>
  @if (data().images[1] || data().images[2]) {
    <div class="header-images">
      <div class="content-wrapper">
        <div class="row container">
          <div class="col-xs-6 col-lg-5">
            @if (data().images[1]; as image) {
              <div data-rellax-speed="-1" parallax class="img-1">
                <app-image [image]="image" [size]="{ dw: 500, dh: 344, mw: 157, mh: 111 }" [isPriority]="true" />
              </div>
            }
          </div>
          <div class="col-xs-6 col-lg-4 col-lg-offset-2">
            @if (data().images[2]; as image) {
              <div data-rellax-speed="-2" parallax class="img-2">
                <app-image [image]="image" [size]="{ dw: 400, dh: 472, mw: 157, mh: 194 }" [isPriority]="true" />
              </div>
            }
          </div>
          <div class="col-lg-1 is-desktop"></div>
        </div>
      </div>
    </div>
  }
</header>
